import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#FECB00', 
            light: '#FFB84D',
            dark: '#E89B0C',
            contrastText: '#000000',
            white: '#FFFFFF',
            light1: '#B0B0B0',
        },
        grey:{
            grey1: '#666',
            grey2: '#999999',
        },
        secondary: {
            main: '#F5A623',
            light: '#FFB84D',
            dark: '#E89B0C',
            contrastText: '#000000',
        },
        background: {
            default: '#0A0A0A', // Very dark background
            paper: '#1A1A1A', // Slightly lighter for cards/papers
        },
        blackColor: {
            black1: '#000',
            black2: '#0A0A0A'
        },
        text: {
            primary: '#FFFFFF',
            secondary: '#f7c618',
            typography: '#f7c618'
        },
        error: {
            main: '#f44336',
        },
        warning: {
            main: '#F5A623',
        },
        info: {
            main: '#2196f3',
        },
        success: {
            main: '#4caf50',
        },
    },
    typography: {
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
        ].join(','),
        h1: {
            fontSize: '2.5rem',
            fontWeight: 600,
            color: '#FFFFFF',
        },
        h2: {
            fontSize: '2rem',
            fontWeight: 600,
            color: '#FFFFFF',
        },
        h3: {
            fontSize: '1.75rem',
            fontWeight: 600,
            color: '#FFFFFF',
        },
        h4: {
            fontSize: '1.5rem',
            fontWeight: 600,
            color: '#FFFFFF',
        },
        h5: {
            fontSize: '1.25rem',
            fontWeight: 600,
            color: '#FFFFFF',
        },
        h6: {
            fontSize: '1rem',
            fontWeight: 600,
            color: '#FFFFFF',
        },
    },
    shape: {
        borderRadius: 12,
    },
    components: {
        // App-wide scrollbars (page, sidebar, tables, modals): thin, dark track, yellow thumb
        MuiCssBaseline: {
            styleOverrides: {
                '*': {
                    scrollbarWidth: 'thin', // Firefox
                    scrollbarColor: 'rgba(254, 203, 0, 0.6) transparent',
                },
                '*::-webkit-scrollbar': {
                    width: 8,
                    height: 8,
                },
                '*::-webkit-scrollbar-track': {
                    background: 'rgba(255, 255, 255, 0.04)',
                    borderRadius: 8,
                },
                '*::-webkit-scrollbar-thumb': {
                    background: 'rgba(254, 203, 0, 0.6)',
                    borderRadius: 8,
                    border: '2px solid transparent',
                    backgroundClip: 'padding-box',
                },
                '*::-webkit-scrollbar-thumb:hover': {
                    background: '#FECB00',
                    backgroundClip: 'padding-box',
                },
                '*::-webkit-scrollbar-corner': {
                    background: 'transparent',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: 600,
                    borderRadius: 12,
                    padding: '12px 24px',
                },
                contained: {
                    backgroundColor: '#F5A623',
                    color: '#000000',
                    '&:hover': {
                        backgroundColor: '#E89B0C',
                    },
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        backgroundColor: 'rgba(255, 255, 255, 0.05)',
                        borderRadius: 12,
                        '& fieldset': {
                            borderColor: 'rgba(255, 255, 255, 0.1)',
                        },
                        '&:hover fieldset': {
                            borderColor: 'rgba(245, 166, 35, 0.5)',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#F5A623',
                        },
                    },
                    '& .MuiInputLabel-root': {
                        color: '#B0B0B0',
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                    backgroundColor: '#1A1A1A',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                    backgroundColor: '#1A1A1A',
                    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.5)',
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: '#0A0A0A',
                    borderRight: '1px solid rgba(255, 255, 255, 0.1)',
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#0A0A0A',
                    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.5)',
                },
            },
        },
        MuiPickersTextField: {
            styleOverrides: {
                root: {
                    '& .MuiPickersOutlinedInput-root': {
                        backgroundColor: 'rgba(255, 255, 255, 0.05)',
                        borderRadius: 12,
                        '& fieldset': {
                            borderColor: 'rgba(255, 255, 255, 0.1)',
                        },
                        '&:hover fieldset': {
                            borderColor: 'rgba(245, 166, 35, 0.5)',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#F5A623',
                        },
                    },
                    '& .MuiInputLabel-root': {
                        color: '#B0B0B0',
                    },
                },
            },
        },
    },
});

export default theme;